const prefix = "api";
const host = "https://shopcenter.xkw.com";
export default {
  user: {
    logout: `${prefix}/user/logout`,
    info: `${prefix}/user/get-user-info`,
  },
  info: {
    getShopInfo: `${prefix}/shop-center/get-shop`,
    getUserInfo: `${prefix}/shop-center/get-shop-user`,
    updateShopInfo: `${prefix}/shop-center/update-shop-info`,
    uploadLogo: `${prefix}/shop-center/upload-picture-check`,
    getWXMiniUrl: `${prefix}/shop-center/get-mini-program-url`,
    getMessageBoxCount: `${prefix}/shop-center/get-message-box-count`,
  },
  trade: {
    pageIncomePayList: `${prefix}/shop-center/page-income-pay-list`,
  },
  resource: {
    getResourceList: `${prefix}/shop-center/get-resource-list`,
    getStatusList: `${prefix}/shop-center/get-status-tag-list`,
    getAlbumResourceList: `${prefix}/shop-center/get-child-list-by-id`,
    updateDocumentPrice: `${prefix}/shop-center/update-document-price`,
    getUpdateDocumentPriceFrequency: `${prefix}/shop-center/get-update-document-price-frequency`,
    getUpdatePriceCheck: `${prefix}/shop-center/update-price-check`,
  },
  dataShow: {
    getShopStatistics: `${prefix}/shop-center/get-shop-statistics`,
    // 店铺总览数据
    getShopStatisticsV2: `${prefix}/shop-center/get-shop-statistics-v2`,
    getCourseList: `${prefix}/basic-data/get-course-list`,
    getCourseList4Data: `${prefix}/basic-data/get-course-list-for-data`,
    getShopStyleList: `${prefix}/shop-center/page-shop-style-list`,
    getShopNavBarList: `${prefix}/shop-center/page-shop-nav-bar-list`,
  },
  // 数据分析
  dataAnalysis: {
    // 流量数据
    getTrafficData: `${prefix}/shop-center/shop-application-list`,
    // 内容数据总数量
    getContentCount: `${prefix}/shop-center/shop-resource-cnt`,
    // 内容数据-资料/视频
    getContentDocument: `${prefix}/shop-center/shop-document-cnt-list`,
    // 内容数据-专辑
    getContentAlbum: `${prefix}/shop-center/shop-album-cnt-list`,
    // 交易数据-交易概况和趋势图
    getTradeData: `${prefix}/shop-center/shop-sale-cnt-list`,
    // 交易数据-交易省份数据
    getProvinceData: `${prefix}/shop-center/shop-province-sale-cnt-list`,
    // 用户数据
    getUserData: `${prefix}/shop-center/shop-user-cnt-list`,
    // 资产管理
    getPropertyData: `${prefix}/shop-center/shop-property-cnt`,
    // 导出数据接
    exportData: `${prefix}/shop-center/export-shop-data-list`,
  },
  changeData: {
    delShopStyleByIds: `${prefix}/shop-center/del-shop-style`,
    addStylePage: `${prefix}/shop-center/add-shop-style`,
    delShopNavBarByIds: `${prefix}/shop-center/del-shop-nav-bar-style`,
    addNavBar: `${prefix}/shop-center/add-shop-nav-bar-style`,
    updateShopStyle: `${prefix}/shop-center/update-shop-style-status`,
    updateNavBar: `${prefix}/shop-center/update-shop-nar-bar-status`,
    getShopDocumentStatistic: `${prefix}/shop-center/page-shop-document-statistic`,
    exportShopDocumentStatistic: `${prefix}/shop-center/export-shop-document-statistic`,
    getShopArticleStatistic: `${prefix}/shop-center/page-shop-article-statistic`,
  },
  template: {
    getShopLayout: `${prefix}/shop-center/get-shop-layout`,
    updateShopLayout: `${prefix}/shop-center/update-shop-layout`,
    uploadShopImage: `${prefix}/shop-center/upload-shop-image`,
    updateShopImageList: `${prefix}/shop-center/update-shop-image-list`,
    getShopImageList: `${prefix}/shop-center/get-shop-image-list`,
  },
  decoration: {
    getShopState: `${prefix}/shop-center/get-shop-stats`,
    getVideoOrResourceList: `${prefix}/shop-center/page-document-video-list`,
    getCoverPreview: `/${prefix}/shop-center/get-cover-preview`,
    getAlbumList: `${prefix}/shop-center/page-shop-album-list`,
    checktext: `${prefix}/shop-center/check-text`,
    updateDecoration: `${prefix}/shop-center/update-shop-style-status`,
    uploadEditorImage: `${prefix}/shop-center/upload-picture-check`,
    updateTabDecoration: `${prefix}/shop-center/add-shop-tab-item`,
    getTabDecoration: `${prefix}/shop-center/select-shop-tab-item-list`,
    getArticleListEs: `${prefix}/shop-center/get-article-list-es`,
    getDiscountList: `${prefix}/shop-center/get-shop-all-activity-doc-ids`,
  },
  shopResource: {
    getStageAndSubject: `${prefix}/basic-data/get-stage-course-list`,
    getStageList: `${prefix}/basic-data/get-stage-list`,
    getScenarioList: `${prefix}/basic-data/get-scenario-list`,
    getCourseList: `${prefix}/basic-data/get-course-list-by-stage`,
    getTypeList: `${prefix}/basic-data/get-type-list`,
    pageAlbumList: `${prefix}/shop-center/page-album-list`,
    pageResourceInfoList: `${prefix}/shop-center/page-resource-info-list`,
    getResourceDetails: `${prefix}/shop-center/get-resource-detail`,
    updateResourceInfo: `${prefix}/shop-center/update-resource-info`,
    uploadResourceInfo: `${prefix}/shop-center/upload-resource-info`,
    uploadResourceInfoV2: `${prefix}/shop-center/upload-resource-info-v2`,
    uploadResourceInfoV3: `${prefix}/shop-center/upload-resource-info-v3`,
    uploadVideoIntroducePhoto: `${prefix}/shop-center/ico-address/upload/file`,
    // 自动推断资料标签
    autoInferResourceTag: `${prefix}/shop-center/infer-tag-by-title`,
    delArticle: `${prefix}/shop-center/del-article`,
    updateArticle: `${prefix}/shop-center/update-article`,
    // 文章封面上传
    uploadCover: `${prefix}/shop-center/upload-article-cover`,
    // 存为草稿或者保存文章
    SaveOrInsertArticle: `${prefix}/shop-center/insert-article`,
    // 获取文章详情
    getArticleDetail: `${prefix}/shop-center/get-article-detail`,
    getArticleList: `${prefix}/shop-center/page-article-list`,
    // 文章更新
    updateArticleContent: `${prefix}/shop-center/update-article-detail`,
    exportArticleList: `${host}/${prefix}/shop-center/export-article-list`,
    exportDocumentList: `${host}/${prefix}/shop-center/export-document-list`,
    exportAlbumList: `${host}/${prefix}/shop-center/export-album-list`,
    exportVideoList: `${host}/${prefix}/shop-center/export-video-list`,
    checkResourceRukuStatus: `${prefix}/shop-center/resource-had-ruku`,
    uploadReAuditImg: `${host}/${prefix}/shop-center/ico-address/upload/file`,
    checkResourceRejectDate: `${prefix}/shop-center/get-resource-reject-date`,
    postResourceRejectReAudit: `${prefix}/shop-center/post-resource-reject-re-audit`,
    hadPostResourceRejectReAudit: `${prefix}/shop-center/had-post-resource-reject-re-audit`,
    // 专辑上传-年级
    getGradeList: `${prefix}/basic-data/get-grades-list`,
    // 专辑上传-地区
    getAreaList: `${prefix}/basic-data/get-province-list`,
    // 创建专辑
    createAlbum: `${prefix}/shop-center/add-album`,
    // 获取专辑详情
    getAlbumDetail: `${prefix}/shop-center/get-album`,
    // 修改专辑
    updateAlbum: `${prefix}/shop-center/update-album`,
  },
  // 阿里云上传
  ossUpload: {
    getOssUploadToken: `${prefix}/shop-center/get-oss-token`,
    aliYun: "//zxxk-repo1.oss-cn-hangzhou.aliyuncs.com",
  },
  // article: {
  //   uploadCover: `${prefix}/shop-center/upload-article-cover`,
  // },
  employee: {
    getEmployeeList: `${prefix}/shop-center/page-query-employee-list`,
    addEmployee: `${prefix}/shop-center/add-employee`,
    isRealName: `${prefix}/shop-center/is-real-name-auth`,
    delEmployee: `${prefix}/shop-center/del-employee`,
    updateEmployee: `${prefix}/shop-center/update-employee`,
  },
  // 店铺认证
  authentication: {
    // 个人认证信息
    getIsPerson: `${prefix}/user/get-real-name-auth-empty-params`,
    // 企业认证信息
    getIsEnterprise: `${prefix}/user/get-shop-real-name-auth`,
    // 提交企业认证
    commitEnterpriseInfo: `${prefix}/user/post-shop-real-name-auth`,
  },
  activity: {
    pageShopActivityList: `${prefix}/shop-center/page-shop-activity-list`,
    addShopActivity: `${prefix}/shop-center/add-shop-activity`,
    delShopActivity: `${prefix}/shop-center/del-shop-activity`,
    getActivityData: `${prefix}/shop-center/page-shop-activity-statistics-list`,
    updateActivity: `${prefix}/shop-center/update-shop-activity`,
    getActivityInfo: `${prefix}/shop-center/get-activity-by-id`,
    getVideoOrResourceListV2: `${prefix}/shop-center/page-document-video-list-v2`,
    exportActivityData: `${host}/${prefix}/shop-center/export-activity-data-list`,
    checkResource: `${prefix}/shop-center/check-activity-resource`,
  },
  // 创作学院
  creatCollege: {
    // 获取课程
    getCourseList: `${prefix}/shop-center/page-lesson-list`,
    // 获取课程分类
    getCourseCategory: `${prefix}/basic-data/get-course-category-tree`,
    // 获取学习记录
    getRecordsList: `${prefix}/shop-center/page-lesson-play-record-list`,
    // 获取学习记录统计
    getRecordsStatistics: `${prefix}/shop-center/get-lesson-play-record-data`,
    // 获取课程视频
    getCourseVideo: `${prefix}/shop-center/play-lesson`,
    // 学习记录上报
    uploadRecords: `${prefix}/shop-center/upload-lesson-play-record`,
  },
};
